









































import Vue from "vue";
import _ from "lodash";
import AppFormLogicMixin from "@/plugins/AppFormLogicMixin";
import Api from "@/api/Api";
export default Vue.extend({
  mixins: [AppFormLogicMixin],
  computed: {
    rawPostData() {
      return (this as any).updateEmail;
    },
    validateMethod() {
      return "patch";
    },
    validateUrl() {
      return (
        "/api/adv/user_logins/" +
        Api.singleton().jwtToken.currentTokenObject?.user_login_id +
        // this.$store.state.jwtToken.user_login_id +
        "/update_email/validate"
      );
    },
    execMethod() {
      return "patch";
    },
    execUrl() {
      return (
        "/api/adv/user_logins/" +
        Api.singleton().jwtToken.currentTokenObject?.user_login_id +
        // this.$store.state.jwtToken.user_login_id +
        "/update_email"
      );
    }
  },
  methods: {
    async onComplete(res: { refreshToken: string }) {
      if (Api.singleton().jwtToken.impersonatedJwtTokenObject) {
        await Api.singleton().jwtToken.refreshImpersonatedToken(
          res.refreshToken
        );
      } else {
        await Api.singleton().jwtToken.refreshToken(res.refreshToken);
      }

      this.$router.push({
        name: "AdvertiserEmailComplete"
      });
    }
  },
  data() {
    return {
      violations: {},
      currentEmail: (Api.singleton().jwtToken.currentTokenObject || {}).username,
      updateEmail: {
        newEmail: ""
      },
      isLoading: false,
      phase: "input",
      targetAdvertisementId: this.$route.query.advertisement
    };
  }
});
